<div class="m-header">
  <a [routerLink]="['/default/']" class="b-brand">
    <!-- ========   change your logo hear   ============ -->
    <img src="assets/images/logo-dark.svg" alt="darkMode-logo" class="logo" />
  </a>
  <!-- ======= Menu collapse Icon ===== -->
  <div class="pc-h-item">
    <a href="javascript:void(0)" class="pc-head-link head-link-secondary m-0 mobile-menu"
      [ngClass]="{ on: navCollapsed() }" id="sidebar-hide mobile-collapse" (click)="navCollapse()"
      title="Click to Menu Collapse">
      <i class="ti ti-menu-2"></i>
    </a>
  </div>
</div>